module.exports = __webpack_public_path__ + "3678bcda39e91f2ae21672fa7bb8a728.svg";